import { Box, IconButton, Typography, Stack, Divider } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Field } from 'formik';
import ImagePicker from './ImagePicker';
import { EventFormValues } from 'src/schema';

interface ViewModeProps {
    clientLogoUrl: string | null | undefined;
}

export function ClientLogoViewMode({ clientLogoUrl }: ViewModeProps) {
    if (!clientLogoUrl) return null;

    return (
        <Box mt={2} display="flex" flexDirection="column" alignItems="center">
            <Divider sx={{ width: '100%', mb: 2 }} />
            <Stack direction="column" spacing={1} sx={{ position: 'relative', alignItems: 'center' }}>
                <Typography variant="h6" sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                    Client Logo
                </Typography>
                <Box
                    component="img"
                    src={clientLogoUrl}
                    alt="Client Logo"
                    sx={{
                        maxWidth: 200,
                        maxHeight: 200,
                        objectFit: 'contain',
                        margin: 'auto',
                    }}
                />
            </Stack>
        </Box>
    );
}

interface EditModeProps {
    values: EventFormValues;
    setFieldValue: (field: string, value: any) => void;
    clientLogoUrl: string | null | undefined;
    /** Called when the user selects a new logo file (so we only upload when they changed it). */
    onNewLogoSelected?: () => void;
}

export function ClientLogoEditMode({ values, setFieldValue, onNewLogoSelected }: EditModeProps) {
    return (
        <Box mt={2}>
            <Divider sx={{ width: '100%', mb: 2 }} />
            <Stack direction="column" spacing={1} sx={{ position: 'relative' }}>
                <Stack direction="row" spacing={1} sx={{ alignItems: 'center', justifyContent: 'center' }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Client Logo
                    </Typography>
                    {values.clientLogo && (
                        <IconButton
                            onClick={() => {
                                setFieldValue('clientLogo', null);
                            }}
                            size="small"
                        >
                            <DeleteIcon />
                        </IconButton>
                    )}
                </Stack>
                <Field name="clientLogo">
                    {({ field, form, meta }: any) => (
                        <ImagePicker field={field} form={form} meta={meta} label="Image upload:" onFileSelected={onNewLogoSelected} />
                    )}
                </Field>
            </Stack>
        </Box>
    );
}
